import React, { useEffect, useRef, useState } from 'react';

const INTERVAL_MS = 5000;

/**
 * Lágy áttűnéses képváltó. Automatikusan vált, de megáll, ha az egér rajta van
 * vagy a felhasználó megfogja (touch). Egy kép esetén statikus marad.
 */
const PhotoSlider = ({ photos = [], className = '', imgClassName = '', sizes, testId = 'photo-slider' }) => {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const timer = useRef(null);
  const multiple = photos.length > 1;

  useEffect(() => {
    if (!multiple || paused) return undefined;
    timer.current = setInterval(() => setIndex((i) => (i + 1) % photos.length), INTERVAL_MS);
    return () => clearInterval(timer.current);
  }, [multiple, paused, photos.length]);

  if (!photos.length) return null;

  return (
    <div
      data-testid={testId}
      className={`relative overflow-hidden bg-[#2a2f38] ${className}`}
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onTouchStart={() => setPaused(true)}
      onTouchEnd={() => setPaused(false)}
    >
      {photos.map((p, i) => (
        <picture key={p.id}>
          <source srcSet={p.webp} type="image/webp" />
          <img
            src={p.fallback || p.webp}
            alt={p.alt}
            data-testid={`${testId}-img-${i}`}
            aria-hidden={i !== index}
            className={`absolute inset-0 w-full h-full ${p.fit === 'contain' ? 'object-contain' : 'object-cover'} transition-opacity duration-[900ms] ease-in-out ${
              i === index ? 'opacity-100' : 'opacity-0'
            } ${imgClassName}`}
            style={{ objectPosition: p.position || 'center 20%' }}
            loading={i === 0 ? 'eager' : 'lazy'}
            decoding="async"
            sizes={sizes}
          />
        </picture>
      ))}

      {multiple && (
        <div className="absolute bottom-3 left-1/2 -translate-x-1/2 z-10 flex items-center gap-2">
          {photos.map((p, i) => (
            <button
              key={p.id}
              type="button"
              aria-label={`${i + 1}. kép megjelenítése`}
              data-testid={`${testId}-dot-${i}`}
              onClick={() => setIndex(i)}
              className={`h-2.5 rounded-full transition-all duration-300 ${
                i === index ? 'w-7 bg-yellow-500' : 'w-2.5 bg-white/60 hover:bg-white'
              }`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default PhotoSlider;
